module.exports = __webpack_public_path__ + "img/koishi komeiji_sc2.60b8152f.png";